import React, { useState, useEffect, useRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { buildInvoiceConfirmDetails } from '../utils/invoiceConfirmDetails';

const RenewApprovals = ({
  approvalList,
  getListFilterData,
  filterDropdownList = null,
  fetchZones,
  getFetchZones = null,
  getRenewalApprovalList,
  acceptRenewalApproval,
  rejectRenewalApproval,
  getContractDetails,
  viewDetails,
}) => {
  const [listData, setListData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [showAcceptConfirm, setShowAcceptConfirm] = useState(false);
  const acceptInFlightRef = useRef(false);

  const input = {
    remarks: '',
  };
  const [remarks, setRemarks] = useState(input);

  const resolveRenewalRow = (actionObj) => {
    const rows = approvalList?.resultSets;
    if (!Array.isArray(rows) || !actionObj) {
      return actionObj || {};
    }
    return (
      rows.find(
        (row) =>
          String(row.id) === String(actionObj.id) &&
          (actionObj.comm_id == null ||
            String(row.comm_id) === String(actionObj.comm_id))
      ) || actionObj
    );
  };

  const commercial = viewDetails?.postsale_data?.commercial ?? {};
  const renewalInvoiceOwnerName =
    commercial?.ownership_user_name ||
    commercial?.created_by_name ||
    resolveRenewalRow(actionData?.actionObj)?.invoice_owner_name ||
    '';
  const invoiceConfirmDetails = buildInvoiceConfirmDetails(
    viewDetails?.postsale_data
  );

  const headerBtns = () => {
    return (
      <Fragment>
        {/*<Button*/}
        {/*  onClick={filterToggle}*/}
        {/*  className="filter-hamburger btn btn-transparent"*/}
        {/*>*/}
        {/*  <img src={Images?.Filter} alt="" />*/}
        {/*  {localization.showFilters}*/}
        {/*</Button>*/}
      </Fragment>
    );
  };

  useEffect(() => {
    if (getRenewalApprovalList !== null) {
      (async () => {
        setIsLoading(true);
        await getRenewalApprovalList(null, 1);
        setIsLoading(false);
      })();
    }
  }, [getRenewalApprovalList]);

  const Headers = [
    'Lead Number',
    'Contract No',
    'Client Name',
    'Lead Category',
    'Zone',
    'Area',
    'Requested On',
    'Approve/Reject',
    'Action',
  ];

  useEffect(() => {
    const tableData = [
      'id',
      'lead_no',
      'comm_id',
      'client_name',
      'lead_category',
      'zone',
      'area',
      'contract_creation_date',
    ];

    if (approvalList !== 'undefined' && approvalList !== {} && approvalList.resultSets) {
      const data = approvalList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            'Approve/Reject': '',
            Action: [
              {name: 'View Details', link: '/dashboard/contract-details/' + element.comm_id},
              {name: "Edit Contract", link: '/dashboard/edit-renew-contract/' + element.comm_id},
            ]
          }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(approvalList.total / approvalList.per_page));
    }
  }, [approvalList]);

  const updateApproval = async (data) => {
    setActionData(data);
    if (data.action === 'accept') {
      const fullRow = resolveRenewalRow(data.actionObj);
      const requestData = {
        lead_id: fullRow?.id ?? data.actionObj?.id,
        commId: fullRow?.comm_id ?? data.actionObj?.comm_id,
      };
      const leadType = fullRow?.lead_type_id ?? fullRow?.lead_type;
      if (
        leadType !== undefined &&
        leadType !== null &&
        leadType !== '' &&
        String(leadType) !== 'undefined'
      ) {
        requestData.lead_type = leadType;
      }
      if (typeof getContractDetails === 'function') {
        setIsLoading(true);
        try {
          await getContractDetails(requestData);
        } finally {
          setIsLoading(false);
        }
      }
      setShowAcceptConfirm(true);
    } else {
      setIsModal(true);
      setIsLoading(false);
    }
  };

  const confirmAcceptRenewal = async () => {
    if (!actionData?.actionObj || acceptInFlightRef.current) {
      return;
    }
    acceptInFlightRef.current = true;
    const fullRow = resolveRenewalRow(actionData.actionObj);
    const requestData = {
      lead_id: fullRow?.id ?? actionData.actionObj.id,
      comm_id: fullRow?.comm_id ?? actionData.actionObj.comm_id,
      remarks: '',
    };
    setIsLoading(true);
    setShowAcceptConfirm(false);
    try {
      const response = await acceptRenewalApproval(requestData);
      if (response) {
        await getRenewalApprovalList(null, 1);
        setIsModal(true);
      }
    } finally {
      acceptInFlightRef.current = false;
      setIsLoading(false);
    }
  };

  const handleContinue = async () => {
    setIsModal(false);
    const requestData = {
      lead_id: actionData.actionObj.id,
      comm_id: actionData.actionObj.comm_id,
      remarks: remarks.remarks,
    };
    setIsLoading(true);
    await rejectRenewalApproval(requestData).then(async (response) => {
      setIsLoading(false);
      if (response) {
        await getRenewalApprovalList(null, 1);
        setIsSuccessModel(true);
      }
    });
  };
  const handleModalHide = () => setIsModal(false);
  const handleRejectModalHide = () => setIsSuccessModel(false);

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <Link to="#" onClick={func} className="btn btn-transparent">
          {localization.returnToApproval}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </div>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getRenewalApprovalList(filter, val.selected + 1);
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      await getListFilterData(3);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getRenewalApprovalList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.renewApproval}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={Headers}
        detailList={approvalList && approvalList.resultSets}
        onChange={(data) => updateApproval(data)}
        srNo={approvalList?.from}
        pageCount={pageCount}
        onPageChange={onPageChange}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'8'}
        getZones={(val) => getZones(val)}
        listFilterData={filterDropdownList && filterDropdownList.data}
        zones={getFetchZones && getFetchZones.data}
        filterPreSalesListing
      />

      <ModalPop
        title={localization.updatedSuccessfully}
        show={isStatusSuccess}
        handleModalHide={closeSuccess}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadStatusupdatedsuccessfully}</h5>
          <Link to="#" onClick={closeSuccess} className="btn btn-transparent">
            {localization.continue}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.conf}
        show={showAcceptConfirm}
        handleModalHide={() => setShowAcceptConfirm(false)}
        modalSize="md"
      >
        <div className="modal-body" style={{ paddingTop: 8 }}>
          <div className="text-center mb-3">
            <h5 style={{ marginBottom: 6 }}>Confirm renewal approval</h5>
            <p style={{ margin: 0, color: '#6b7280', fontSize: 13 }}>
              Review invoice ownership and commercial details before approving.
            </p>
          </div>

          <div
            style={{
              maxWidth: 560,
              margin: '0 auto 16px',
              textAlign: 'left',
            }}
          >
            <div
              style={{
                background: 'linear-gradient(135deg, #f8f5ff 0%, #f3eefc 100%)',
                border: '1px solid #e4daf7',
                borderRadius: 10,
                padding: '14px 16px',
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  fontSize: 11,
                  letterSpacing: 0.4,
                  textTransform: 'uppercase',
                  color: '#7c5cbf',
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                Invoice will be tagged to
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  background: '#fff',
                  borderRadius: 8,
                  padding: '10px 12px',
                  border: '1px solid #eee8f8',
                }}
              >
                <div
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    background: '#6030be',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    fontSize: 14,
                    flexShrink: 0,
                  }}
                >
                  {(renewalInvoiceOwnerName || '?').charAt(0).toUpperCase()}
                </div>
                <div style={{ fontSize: 16, fontWeight: 600, color: '#1f2937' }}>
                  {renewalInvoiceOwnerName || '—'}
                </div>
              </div>
            </div>

            {invoiceConfirmDetails.summaryRows.length > 0 && (
              <div
                style={{
                  background: '#fff',
                  border: '1px solid #ebe7f2',
                  borderRadius: 10,
                  padding: '12px 14px',
                  marginBottom: 12,
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    letterSpacing: 0.4,
                    textTransform: 'uppercase',
                    color: '#6b7280',
                    fontWeight: 600,
                    marginBottom: 10,
                  }}
                >
                  Contract summary
                </div>
                <div style={{ display: 'grid', gap: 8 }}>
                  {invoiceConfirmDetails.summaryRows.map((row) => (
                    <div
                      key={row.label}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 12,
                        borderBottom: '1px solid #f3f4f6',
                        paddingBottom: 6,
                      }}
                    >
                      <span style={{ color: '#6b7280', fontSize: 13 }}>
                        {row.label}
                      </span>
                      <span
                        style={{
                          color: '#111827',
                          fontSize: 13,
                          fontWeight: 600,
                          textAlign: 'right',
                        }}
                      >
                        {row.value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {invoiceConfirmDetails.sections.map((section) => (
              <div
                key={section.title}
                style={{
                  background: '#fcfcfd',
                  border: '1px solid #ebe7f2',
                  borderLeft: '3px solid #6030be',
                  borderRadius: 8,
                  padding: '12px 14px',
                  marginBottom: 12,
                }}
              >
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: '#374151',
                    marginBottom: 8,
                  }}
                >
                  {section.title}
                </div>
                <div style={{ display: 'grid', gap: 4 }}>
                  {section.lines.map((line, index) => (
                    <div
                      key={`${section.title}-${index}`}
                      style={{ fontSize: 13, color: '#4b5563' }}
                    >
                      {line}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div
            className="d-flex justify-content-center align-items-center"
            style={{ gap: '12px', flexWrap: 'wrap' }}
          >
            <Button
              className="btn btn-primary"
              style={{ width: 'auto', minWidth: 150 }}
              onClick={confirmAcceptRenewal}
              disabled={isLoading}
            >
              Confirm Approval
            </Button>
            <Button
              className="btn btn-transparent"
              style={{ width: 'auto', minWidth: 110 }}
              onClick={() => setShowAcceptConfirm(false)}
              disabled={isLoading}
            >
              Cancel
            </Button>
          </div>
        </div>
      </ModalPop>

      <ModalPop
        title={
          actionData && actionData.action === 'reject'
            ? localization.rejectConf
            : localization.conf
        }
        show={isModal}
        handleModalHide={handleModalHide}
        actionData={actionData}
      >
        {actionData && actionData.action === 'reject' ? (
          <Fragment>
            <div className="modal-body">
              <div className="text-center">
                <h5>{localization.rejectRenewalApproval}</h5>
                <div className="form-group">
                  <ConstantInput
                    label={localization.addRemark}
                    required
                    isStarRequired={true}
                    type="text"
                    handleChange={(val) => {
                      setRemarks({ ...setRemarks, remarks: val });
                    }}
                  />
                </div>
                <Button
                  className="btn btn-primary"
                  onClick={handleContinue}
                  disabled={!remarks.remarks}
                >
                  {localization.continue}{' '}
                  <img src="../images/arrow-right.png" alt="" />
                </Button>
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            {successIconBox(localization.contractApproved, handleModalHide)}
          </Fragment>
        )}
      </ModalPop>
      <ModalPop
        title={localization.rejectSuccessfully}
        show={isSuccessModel}
        handleModalHide={handleRejectModalHide}
      >
        {successIconBox(localization.approveRenewalReject, handleRejectModalHide)}
      </ModalPop>
    </Layout>
  );
};

RenewApprovals.propTypes = {
  approvalList: PropTypes.any,
  getRenewalApprovalList: PropTypes.any,
  acceptRenewalApproval: PropTypes.any,
  rejectRenewalApproval: PropTypes.any,
  getContractDetails: PropTypes.func,
  viewDetails: PropTypes.any,
};

export default RenewApprovals;
